import FormSwitchWithText from "../yoello-lib/modules/dynamicForms/FormComponents/FormSwitchWithText";
import IDynamicFormRow from "../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow";
import FormTextBox from "../yoello-lib/modules/dynamicForms/FormComponents/FormTextBox";
import { AddItemsButton } from "../components/menu/products/extras/ui/AddItemsButton";
import { dialogKeys } from "../const/URL.const";
import { DeleteItems } from "../yoello-lib/modules/dynamicForms/CustomFormComponents/DeleteItems";
import Styles from "../scss/formFields.module.scss";
import { PrintersDialog } from "../components/printers/PrinterDialog";
import { Button } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { FilterTypes } from "../components/printers/util";
import { IPrinterFormState } from "../components/printers/types";
import { filterConfig, printerFilterTitles } from "../components/printers/util";

interface IPrintersFormProps {
  t: (key: string) => string,
  goToNextStep: Function,
  goToPrevStep: Function,
  setProps: Function,
  getProps: Function,
  id: string,
  formData: IPrinterFormState,
  venueId: string,
  path: string
  isLoading: boolean,
  callAPI: Function,
  closeAllModals: Function,
  onDeleteFilter: Function,
  setUpFilters: (data:any[], filterType:FilterTypes) => void
}

export function PrintersForm(props: IPrintersFormProps): IDynamicFormRow[] {
  const {
    t, 
    path, 
    goToNextStep, 
    goToPrevStep, 
    setProps, 
    getProps, 
    id, 
    formData,
    venueId,
    isLoading,
    callAPI,
    closeAllModals,
    onDeleteFilter,
    setUpFilters
  } = props;
  

  function isValidMacAddress(address: string): boolean {
    const regex = /^[a-fA-F0-9]{2}(:[a-fA-F0-9]{2}){5}$/
    return regex.test(address);
  }

  function isNotEmptyName(name: string) {
    const regex = /^\s+$/
    return !regex.test(name);
  }

  let rows: IDynamicFormRow[] = [
      {
          label: "printerSettings.form.printerName",
          keyName: "name_public",
          Component: FormTextBox,
          disabled: false,
          registerOptions:
          {
              required: true,
              validate: {
                isNotEmptyName
              }
          },
          gridColumnOptions: {
            formCol: 12
          },
      },
      {
        label: "printerSettings.form.printerMacAddress",
        keyName: "mac_address",
        Component: FormTextBox,
        disabled: id !== 'create',
        registerOptions:
        {
            required: true,
            validate: {
              isValidMacAddress
            }
        },
        gridColumnOptions: {
          formCol: 12
        },
        formProps: {
          tooltip: "printerSettings.form.macAddressTooltip"
        }
      }, 
      {
          label: " ",
          formProps: {
            secondLabel: "printerSettings.form.enablePrinter",
          },
          Component: FormSwitchWithText,
          keyName: "enabled",
          gridColumnOptions: {
              formCol: 12
          },
          className: Styles.FormSwitchWithText,
      },
  ];

  Object.keys(FilterTypes).forEach((item) =>{
    rows.push({
      Component: AddItemsButton,
      label: t(printerFilterTitles[item].label),
      keyName: item,
      formProps: {
        secondLabel: t(printerFilterTitles[item].secondLabel),
        formData,
        dialogTitle: t(printerFilterTitles[item].dialogTitle),
        itemsList: formData[item as FilterTypes],
        setPreviousData: true,
        selectedItemsText: t(printerFilterTitles[item].selectedItemsText),
        isFormDialog: false,
        fieldList: [
          {
            key: "id",
            modifier: (i:any, data: any) => {
              return <div>
                <p>{data[`${filterConfig[item].propNameToDisplay}`]}</p>
              </div>
            }
          },
          {
            key: "name",
            modifier: (enabled: boolean, cardData: any) => {
              return <Button onClick={() => onDeleteFilter(cardData.id, item)}>
                <CloseIcon />
              </Button>
            }
          }
        ],
        dataComponentName: `${item}_FILTER`,
        goToNextStep,
        goToPrevStep,
        setProps,
        getProps,
        id,
        prevModal: dialogKeys.PRINTER,
        parentPath: path,
        formDataKey: "itemData",
        notFilterIDs:true,
        dialogProps: {
          APIDefinition: filterConfig[item].APIDefinition,
          queryParams: item === FilterTypes.ORDER_TYPE ? `${venueId}/order_types`: undefined,
          propNameToDisplay: filterConfig[item].propNameToDisplay,
          onSubmit: (data:any) => setUpFilters (data , item as FilterTypes),
          submitText: t(printerFilterTitles[item].submitText),
          subLabelKey: filterConfig[item].subLabelKey,
          hasSubmitCancelButtons: true,
          isVirtualizeList: true,
          persistSelectedFilters: true,
          parentModalKey: dialogKeys.PRINTER,
          isLoading,
        }
      },
    },)
   })
  if (id !== 'create') {
    rows.push({
      label: "delete.label",
      Component: DeleteItems,
      formProps: {
          keyLabel: "printers",
          title:t("printerSettings.form.editFormTitle"),
          rawProps: props,
          item: {
            ...formData,
            id
          },
          callAPI,
          closeAllModalsOnSubmit: true,
          ParentComponent: PrintersDialog,
          closeAllModals: () => closeAllModals(path)
      },
      keyName: "delete",
    })
  }

  return rows;
}